import { SettingStoreMutations } from "@/constants/store/setting/settingStoreConstants";
import { Setting } from "@/dataModel";
import { SettingState } from "@/typings/store/states/SettingStoreState";

export default {
  [SettingStoreMutations.SET_AI_SETTING](state: SettingState, setting: Setting) {
    state.AI_Setting = setting;
  },
};
